


const AppWrapper = (props) => {
    return <div className="container-margin">{props.children}</div>
}
export default AppWrapper;